import { render, staticRenderFns } from "./UserQualifications.vue?vue&type=template&id=52f3e29c&"
import script from "./UserQualifications.vue?vue&type=script&lang=js&"
export * from "./UserQualifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports